export default __webpack_public_path__ + "static/media/logo.ae8f687f.svg";